import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { pronunciationData, getDataForDifficulty } from './data/skills/speaking/pronunciation';

export default function PronunciationCourse() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : pronunciationData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
